import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=48a3ef5a&scoped=true&"
import script from "./Aside.vue?vue&type=script&lang=js&"
export * from "./Aside.vue?vue&type=script&lang=js&"
import style0 from "./Aside.vue?vue&type=style&index=0&id=48a3ef5a&scoped=true&lang=css&"
import style1 from "./Aside.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a3ef5a",
  null
  
)

export default component.exports